export type AdsOriginKind = 'meta' | 'google' | 'other';

export function resolveAdsOriginKind(input: {
    originLabel?: string | null;
    source?: string | null;
    ctwaClid?: string | null;
    googleClickId?: string | null;
    sourceId?: string | null;
    adId?: string | null;
}): AdsOriginKind {
    const label = (input.originLabel || '').toLowerCase();

    if (
        input.googleClickId ||
        input.source === 'google_ads' ||
        label === 'google ads' ||
        input.sourceId === 'google_ads'
    ) {
        return 'google';
    }

    if (
        input.ctwaClid ||
        input.adId ||
        input.source === 'meta_ads' ||
        label === 'meta ads' ||
        (input.sourceId && input.sourceId !== 'google_ads' && input.sourceId !== 'link_tracking')
    ) {
        return 'meta';
    }

    return 'other';
}

export function adsGroupLabel(kind: AdsOriginKind): string {
    if (kind === 'google') return 'Grupo de anúncios';
    if (kind === 'meta') return 'Conjunto';
    return 'Grupo';
}

const LOCKED_ORIGIN_LABELS = new Set([
    'meta ads',
    'faceads',
    'google ads',
    'instagram direct',
]);

/** Prefere rótulo travado (ads / IG Direct) entre candidatos; senão o primeiro preenchido. */
export function preferLockedOriginLabel(
    ...candidates: Array<string | null | undefined>
): string | undefined {
    const filled = candidates.map((c) => (typeof c === 'string' ? c.trim() : '')).filter(Boolean);
    const locked = filled.find((label) => LOCKED_ORIGIN_LABELS.has(label.toLowerCase()));
    return locked ?? filled[0];
}
